import type { Ref } from "vue";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

// TODO: Consider using `breakpointsSematic`
const customBreakpoints = {
  "3xl": 2560,
  "4xl": 3440,
  "5xl": 3840,
};

const breakpoints = useBreakpoints({ ...breakpointsTailwind, ...customBreakpoints });
const sm = breakpoints.smaller("sm");
const md = breakpoints.between("sm", "md");
const lg = breakpoints.between("md", "lg");
const xl = breakpoints.between("lg", "xl");
const xl2 = breakpoints.between("xl", "2xl");
const xl3 = breakpoints.between("2xl", "3xl");
const xl4 = breakpoints.between("3xl", "4xl");
const xl5 = breakpoints.between("4xl", "5xl");
const xl6 = breakpoints["5xl"];

export interface IUseListLimitBreakpoints {
  sm: number;
  md: number;
  lg: number;
  xl: number;
  xl2: number;
  xl3: number;
  xl4: number;
  xl5: number;
  xl6: number;
}
export interface IUseListLimitOptions {
  limit?: number;
  breakpoints?: IUseListLimitBreakpoints;
}

/**
 * Will return a list of items sliced with the specified limit options.
 */
export default function useListLimit<T>(items: Ref<T[]>, options: IUseListLimitOptions): Ref<T[]> {
  return computed(() => {
    if (options.breakpoints) {
      if (sm.value)
        return items.value.slice(0, options.breakpoints.sm);
      if (md.value)
        return items.value.slice(0, options.breakpoints.md);
      if (lg.value)
        return items.value.slice(0, options.breakpoints.lg);
      if (xl.value)
        return items.value.slice(0, options.breakpoints.xl);
      if (xl2.value)
        return items.value.slice(0, options.breakpoints.xl2);
      if (xl3.value)
        return items.value.slice(0, options.breakpoints.xl3);
      if (xl4.value)
        return items.value.slice(0, options.breakpoints.xl4);
      if (xl5.value)
        return items.value.slice(0, options.breakpoints.xl5);
      if (xl6.value)
        return items.value.slice(0, options.breakpoints.xl6);
    } else if (options.limit) {
      return items.value.slice(0, options.limit);
    }

    return items.value;
  });
}
